export default __webpack_public_path__ + "static/media/S_CoreDream_1Thin.50911876.woff";